module.exports = __webpack_public_path__ + "static/media/m1_sf_6.1025ec7d.png";